import { render, staticRenderFns } from "./PropertiesItem.vue?vue&type=template&id=6f757547&"
import script from "./PropertiesItem.vue?vue&type=script&lang=js&"
export * from "./PropertiesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports